import React, { useEffect, useState } from 'react';
import './AddDocumentModal.css'; // Unique CSS file link

const AddDocumentModal = ({
  onClose,
  onSubmit,
  initialData = null,
  title = "Add Document",
  submitLabel = "SUBMIT",
}) => {
  const initialName = initialData?.name || '';
  const initialType = initialData?.type || '';
  const initialDescription = initialData?.description || '';

  const [formData, setFormData] = useState({
    name: initialName,
    type: initialType,
    description: initialDescription,
    file: null,
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      name: initialName,
      type: initialType,
      description: initialDescription,
      file: null,
    }));
  }, [initialName, initialType, initialDescription]);

  // Handle File Upload - Kept exactly as provided
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData({ ...formData, file: e.target.files[0] });
    }
  };

  return (
    <div className="adm-doc-overlay">
      <div className="adm-doc-content"> 
        <div className="adm-doc-header">
          <h3>{title}</h3>
          <button type="button" className="adm-doc-close-x" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="adm-doc-body">
          <div className="adm-doc-form-grid">
            <div className="adm-doc-group">
              <label>Name</label>
              <input 
                type="text" 
                className="adm-doc-control" 
                value={formData.name}
                onChange={e => setFormData({...formData, name: e.target.value})} 
              />
            </div>
            <div className="adm-doc-group">
              <label>Type</label>
              <input 
                type="text" 
                className="adm-doc-control" 
                value={formData.type}
                onChange={e => setFormData({...formData, type: e.target.value})} 
              />
            </div>
            <div className="adm-doc-group">
              <label>Description</label>
              <input 
                type="text"
                className="adm-doc-control" 
                value={formData.description}
                onChange={e => setFormData({...formData, description: e.target.value})}
              />
            </div>
            
            <div className="adm-doc-group adm-doc-group-file">
              <label>Document</label>
              <div className="adm-doc-file-shell">
                <input 
                  type="file" 
                  id="doc-upload-unique" 
                  onChange={handleFileChange} 
                  className="adm-doc-file-input"
                />
                <label htmlFor="doc-upload-unique" className="adm-doc-file-chooser">
                  Choose File
                </label>
                <span className="adm-doc-file-name">
                  {formData.file ? formData.file.name : "No file chosen"}
                </span>
              </div>
            </div>

          </div>
        </div>
        <div className="adm-doc-footer">
          <button type="button" className="adm-doc-btn adm-doc-submit" onClick={() => onSubmit(formData)}>{submitLabel}</button>
          <button type="button" className="adm-doc-btn adm-doc-cancel" onClick={onClose}>CANCEL</button>
        </div>
      </div>
    </div>
  );
};

export default AddDocumentModal;
